import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import { addActivityQueue, clearActivityQueue } from '../actions/global';

export default handleActions<DamzState['activity'], any>(
  {
    [`${addActivityQueue}`]: (
      state,
      action: ReturnType<typeof addActivityQueue>
    ) => ({
      ...state,
      roomsQueue: [...state.roomsQueue, action.payload.room_id],
    }),
    [`${clearActivityQueue}`]: (
      state,
      action: ReturnType<typeof clearActivityQueue>
    ) => ({
      ...state,
      roomsQueue: [],
    }),
  },
  {
    roomsQueue: [],
  }
);
